export const sorter = (hooks = [], by = 'name', ascending = true) => {
  const sorted = hooks.sort((a, b) => {
    if (a[by] < b[by]) {
      return -1;
    }
    if (a[by] > b[by]) {
      return 1;
    }
    return 0;
  });

  return ascending ? sorted : sorted.reverse();
}

export const filtration = (query, hooks = [], hideDeprecated = true, byType = false) => {
  let filtered = hooks;
  let deprecated = [];
  let types = [];

  const filterByQuery = (h) => {
    if (!query) return h;

    const regexp = new RegExp(query, 'i');

    return (
      regexp.test(h.name)
      || regexp.test(h.description)
      || regexp.test(h.category)
    )
  }

  /*
   If the user wants to hide deprecated hooks, find them so we can filter them out.
   */

  if (hideDeprecated) {
    deprecated = hooks.filter((h) => h.deprecated).map((h) => h.name);
  }

  if (byType !== 'all') {
    types = hooks.filter((h) => h.type === byType).map((h) => h.name);
  } else {
    types = hooks.map((h) => h.name)
  }

  filtered = hooks
    .filter((h) => (deprecated.indexOf(h.name) === -1))
    .filter((h) => (types.indexOf(h.name) > -1))
    .filter(filterByQuery);

  return filtered;
}

/*
  Converts "true" and "false" and numbers to true/false booleans
  Limited use because strings such as "pop" will also be false.
*/

export const stringToBool = (value) => {
  let bool;

  if (!Number.isNaN(value)) {
    bool = !!value;
  } else {
    bool = value.toString() === 'true';
  }

  return bool;
}
